import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import BranchesMap from "../modules/branches-map";

const Home = {
  init() {
    BranchesMap.init();
    Home.shopSlider();
    Home.gridRowSlider();
  },

  shopSlider() {
    const shopEl = $(".shop");
    if (shopEl.length) {
      new Swiper(shopEl.find(".shop-slider")[0], {
        modules: [Pagination, Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,

        pagination: {
          el: shopEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
        navigation: {
          prevEl: shopEl.find(".swiper-button-prev")[0],
          nextEl: shopEl.find(".swiper-button-next")[0],
        },
        breakpoints: {
          1200: {
            slidesPerGroup: 4,
          },
        },
      });
    }
  },


  gridRowSlider() {
    const gridEls = $(".grid-row__slider");
    if (gridEls.length) {
      gridEls.each(function () {
        const gridEl = $(this);

        new Swiper(gridEl.find(".swiper")[0], {
          modules: [Navigation],
          slidesPerView: "auto",
          spaceBetween: 15,

          navigation: {
            prevEl: gridEl.find(".swiper-button-prev")[0],
            nextEl: gridEl.find(".swiper-button-next")[0],
          },
          breakpoints: {
            900: {
              spaceBetween: 20,
            },
          },
        });
      });
    }
  },

};

export default Home;
